import { SingleLineModelSVG } from "./SingleLineModelSVG";
export default SingleLineModelSVG;
